import Col from "components/ui-elements/Col";
import React from "react";
import Input from "./Input";
import DropUpload from "./DropUpload";
const DropUploadCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <DropUpload {...rest} />
    </Col>
  );
};

DropUploadCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-3"
}

export default DropUploadCol;